import React from 'react';
import { Modale, ModaleTitre, ModaleContent } from '@design-system-etat/dsfr-react';
import { useHistory } from 'react-router-dom';
import RoutesDeconnexion from '../../pages/deconnexion/routes';
import { getPath } from '../../utils/router';

const ModaleDeconnexion = () => {
    const history = useHistory();

    const deconnexion = () => {
        history.push(getPath(RoutesDeconnexion));
    };

    return (
        <Modale title="Déconnexion" closeCallback={deconnexion}>
            <ModaleTitre>Déconnexion</ModaleTitre>
            <ModaleContent>
                Vous allez être déconnecté en raison de la mise à jour de votre compte. Merci de
                vous reconnecter.
            </ModaleContent>
        </Modale>
    );
};

export default ModaleDeconnexion;
